import './filter-listing.scss';

const naturalSorter = (as, bs) => {
    var a, b, a1, b1, i = 0, n, L,
        rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
    if (as === bs) return 0;
    a = as.toLowerCase().match(rx);
    b = bs.toLowerCase().match(rx);
    L = a.length;
    while (i < L) {
        if (!b[i]) return 1;
        a1 = a[i],
            b1 = b[i++];
        if (a1 !== b1) {
            n = a1 - b1;
            if (!isNaN(n)) return n;
            return a1 > b1 ? 1 : -1;
        }
    }
    return b[i] ? -1 : 0;
};

const filteringEvent = new Event('listingUpdated');

class FilterListing {

    constructor(el) {
        // store element
        this.el = el;
        // is this a live-filter listing?
        this.liveFiltering = this.el.classList.contains('live-filter-listing');
        // array to store filter settings
        this.filters = [];
        // array to store all tags
        this.allTags = [];
        // find filter controls
        this.filtersForm = el.querySelector('form.filter-listing--filters');
        this.filterControls = [];
        let findFilterControls = this.filtersForm.querySelectorAll('.filter-listing--filters--filter');
        if(findFilterControls.length > 0) {
            findFilterControls.forEach((fc,i) => {
                let filterIndex = parseFloat(fc.dataset.filterIndex);
                // store filterControl in array using index value taken from 'data-filter-index' in HTML
                this.filterControls[filterIndex] = {
                    index: filterIndex,
                    el: fc,
                    tags: []
                }
                let findTags = fc.querySelectorAll('.filter-tag');
                findTags.forEach((t,i) => {
                    this.filterControls[filterIndex].tags[i] = {
                        input: t.querySelector('input[type="checkbox"]'),
                        label: t.querySelector('label').innerHTML,
                    };
                    // add behaviour
                    if(this.liveFiltering) {
                        this.filterControls[filterIndex].tags[i].input.onclick = () => {
                            this.updateFilter(filterIndex);
                        }
                    }
                });
                this.filters[filterIndex] = this.getFilterSetting(filterIndex);
            });
        }
        if(this.liveFiltering) {
            // find results
            this.resultsWrapper = el.querySelector('.filter-listing--results');
            this.results = [];
            let findResults = el.querySelectorAll('.filter-listing--results > li');
            if(findResults.length > 0) {
                findResults.forEach((r,i) => {
                    this.results[i] = {
                        itemIndex: i,
                        el: r,
                        hmItem: r.querySelector('*[data-hm-item]'),
                        filterData: this.processFilterData(r),
                        // text for a-z sorting
                        azValue: r.dataset.sortAz
                    }
                    // sort numeric (eg. price)
                    let n = r.dataset.sortNumeric;
                    this.results[i].numericValue = typeof(n) != 'undefined' ? parseFloat(n) : 0;
                });
            }
            // sorting
            this.virtualArray = [];
            this.sortMode = '';
            this.sortingControl = el.querySelector('.filter-listing--sorting select');
            if(this.sortingControl != null) {
                // create a-z sort order array
                this.sortOrderAZ = [];
                for(let x = 0, l = this.results.length; x < l; x++) {
                    this.sortOrderAZ.push({itemIndex: x, azValue: this.results[x].azValue});
                }
                this.sortOrderAZ.sort(function (a, b) {
                    return naturalSorter(a.azValue, b.azValue);
                });
                // create z-a sort order array
                this.sortOrderZA = this.sortOrderAZ.slice();
                this.sortOrderZA.reverse();
                // create numeric-lh sorting array?
                this.sortOrderNumericLH = [];
                for(let x = 0, l = this.results.length; x < l; x++) {
                    this.sortOrderNumericLH.push({itemIndex: x, numericValue: this.results[x].numericValue});
                }
                this.sortOrderNumericLH.sort(function (a, b) {
                    return (a.numericValue - b.numericValue);
                });
                // create numeric-hl sorting array?
                this.sortOrderNumericHL = this.sortOrderNumericLH.slice();
                this.sortOrderNumericHL.reverse();
                // control behaviour
                this.sortingControl.onchange = () => {
                    window.requestAnimationFrame(() => {
                        this.sort(this.sortingControl.options[this.sortingControl.selectedIndex].value);
                    });
                };
                // look for sort mode in localStorage and apply if exists
                let findSortMode = localStorage.getItem('filterListingSortMode');
                if(findSortMode != null) {
                    this.sort(findSortMode);
                    // update select element
                    let sIndex = 0;
                    for(let x = 0, l = this.sortingControl.options.length; x < l; x++) {
                        if(this.sortingControl.options[x].value == findSortMode) {
                            sIndex = x;
                            break;
                        }
                    }
                    this.sortingControl.selectedIndex = sIndex;
                }
            }
            // reset
            this.resetBtn = el.querySelector('.filter-listing--filters button[type="reset"]');
            if(this.resetBtn != null) {
                this.resetBtn.onclick = () => {
                    setTimeout(() => {
                        for(let x = 0, l = this.filterControls.length; x < l; x++) this.filters[x] = this.getFilterSetting(x);
                        this.sort(this.sortingControl.options[this.sortingControl.selectedIndex].value);
                        this.updateResults();
                    }, 200);
                }
            }
        } else {
            // reset
            this.resetBtn = el.querySelector('.filter-listing--filters button[type="reset"]');
            if(this.resetBtn != null) {
                this.resetBtn.onclick = (e) => {
                    e.preventDefault();
                    if(this.activeTagsWrapper != null) {
                        this.activeTagsWrapper.innerHTML = '';
                    }
                    this.filterControls.forEach(fc => {
                        fc.tags.forEach(t => {
                            t.input.checked = false;
                        });
                    });
                    this.filtersForm.submit();
                }
            }
        }
        // active filters tag list
        this.activeTagsContent = '';
        this.activeTagsWrapper = el.querySelector('ul.filter-listing--active-tags');
        if(this.activeTagsWrapper != null) this.updateActivetags();
    }

    processFilterData(r) {
        let d = [];
        let findData = r.dataset.filterValues;
        if(typeof(findData) != 'undefined') {
            let filter = findData.split('|');
            filter.forEach(f => {
                d.push(f.split(','));
            });
        }
        return d;
    }

    getFilterSetting(getIndex) {
        let filterSetting = [];
        this.filterControls[getIndex].tags.forEach((t,i) => {
            if(t.input.checked) filterSetting.push(i.toString());
        });
        return filterSetting;
    }

    updateFilter(getIndex) {
        this.filters[getIndex] = this.getFilterSetting(getIndex);
        this.updateResults();
    }

    sort(mode) { // sorting uses flex-order and is therefore only visual, not structural
        this.sortMode = mode;
        // store current mode in localStorage
        localStorage.setItem('filterListingSortMode', mode);
        switch(mode) {
            case 'az':
                // alphabetical
                this.virtualArray = this.sortOrderAZ.slice();
                break
            case 'za':
                // reverse alphabetical
                this.virtualArray = this.sortOrderZA.slice();
                break
            case 'numeric-lh':
                // numeric low to high
                this.virtualArray = this.sortOrderNumericLH.slice();
                break
            case 'numeric-hl':
                // numeric high to low
                this.virtualArray = this.sortOrderNumericHL.slice();
                break
            default:
                // default order - clear all order classes
                this.virtualArray = this.results.slice();
                break
        }
        // rearrange dom structure (fixes tabbing + height-matching)
        let frag = document.createDocumentFragment();
        for(let x = 0, l = this.virtualArray.length; x < l; x++) {
            frag.appendChild(this.results[this.virtualArray[x].itemIndex].el);
        }
        this.resultsWrapper.appendChild(frag);
        frag = null;
        window.dispatchEvent(filteringEvent);
    }

    updateActivetags() {
        let ariaHidden = true;
        this.activeTagsWrapper.innerHTML = '';
        this.filterControls.forEach(f => {
            f.tags.forEach((t,i) => {
                if(t.input.checked) {
                    ariaHidden = false;
                    let newLi = document.createElement('LI');
                    newLi.innerHTML = `${t.label}<button type="button" class="btn btn-link p-0"><span class="visually-hidden">remove filter</span><i class="fa-sharp fa-strong fa-times" aria-hidden="true" title="remove filter"></i></button>`;
                    this.activeTagsWrapper.appendChild(newLi);
                    newLi.querySelector('button').onclick = () => {
                        f.tags[i].input.click();
                        if(!this.liveFiltering) {
                            this.filtersForm.submit();
                        }
                    };
                }
            });
        });
        if(ariaHidden) {
            this.activeTagsWrapper.setAttribute('aria-hidden',true);
        } else {
            this.activeTagsWrapper.removeAttribute('aria-hidden');
        }
    }

    updateURL() {
        let url = location.href.replace(/\/$/, "").toString();
        let oldUrl = url;
        let hasQuery = url.indexOf('?') > 0;
        this.filterControls.forEach(f => {
            f.tags.forEach((t,i) => {
                let encodedTag = `cat=${encodeURIComponent(t.label)}`;
                if(t.input.checked) {
                    if(url.indexOf(encodedTag) < 0) {
                        url = hasQuery ? (url + '&' + encodedTag) : (url + '?' + encodedTag);
                    }
                } else {
                    if(url.indexOf(encodedTag) > -1) {
                        url = url.replace('&' + encodedTag, '');
                        url = url.replace('?' + encodedTag, '?');
                        url = url.replace('?&', '?');
                    }
                }
            });
        });
        if(oldUrl != url) history.replaceState(null, null, url);
    }

    updateResults() {
        // update results list
        for(let x = 0, l = this.results.length; x < l; x++) {
            let hideResult = false;
            this.filters.forEach((f,i) => {
                let match = true;
                if(f.length > 0) {
                    f.forEach(ff => {
                        if(!this.results[x].filterData[i].includes(ff)) match = false;
                    });
                    if(!match) hideResult = true;
                }
            });
            if(hideResult) {
                this.results[x].el.setAttribute('aria-hidden', 'true');
                this.results[x].hmItem.setAttribute('data-hm-hidden', true);
            } else {
                this.results[x].el.removeAttribute('aria-hidden');
                this.results[x].hmItem.removeAttribute('data-hm-hidden');
            }
        }
        window.dispatchEvent(filteringEvent);
        // update active tags list?
        if(this.activeTagsWrapper != null) this.updateActivetags();
        // update page url?
        this.updateURL();
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new FilterListing(node);
        }
    });
}